import { Bones, Grid } from '@simplywallst/ui-core';

const AlgoliaSearchLoading = () => (
  <Grid templateColumns={'1fr 72px'} gap="8px">
    <Bones minHeight="40px" />
    <Bones minHeight="40px" />
  </Grid>
);

export default AlgoliaSearchLoading;
